var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 213,
    height: 243,
    viewBox: "0 0 213 243",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 60.92,
    y: 167.037,
    width: 190,
    height: 12,
    transform: "rotate(-45 60.92 167.037)",
    fill: "#7043FF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 214,
    width: 212,
    height: 29,
    fill: "#7043FF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 28.3931,
    y: 134.51,
    width: 190,
    height: 12,
    transform: "rotate(-45 28.3931 134.51)",
    fill: "#7043FF"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 162.743,
    y: 0.160156,
    width: 58,
    height: 12,
    transform: "rotate(45 162.743 0.160156)",
    fill: "#7043FF"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 147.187,
    y: 18.5449,
    width: 56,
    height: 12,
    transform: "rotate(45 147.187 18.5449)",
    fill: "#7043FF"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 40.1467,
    y: 137.455,
    width: 58,
    height: 12,
    transform: "rotate(105 40.1467 137.455)",
    fill: "#7043FF"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 70.5523,
    y: 174.932,
    width: 58,
    height: 12,
    transform: "rotate(165 70.5523 174.932)",
    fill: "#7043FF"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 75.5021,
    y: 185.537,
    width: 64.0359,
    height: 12,
    transform: "rotate(165 75.5021 185.537)",
    fill: "white"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 28.9937,
    y: 133.051,
    width: 64.0359,
    height: 12,
    transform: "rotate(105 28.9937 133.051)",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit_icon.cd98d1da1400004f41ad767b713b2cbf.svg";
export { ForwardRef as ReactComponent };